export enum PAGE_TABS_APPEARANCE {
  UNDERLINE = 'underline',
  VERTICAL_NAVIGATION = 'vertical_navigation',
}
